import * as React from "react";

import { cn } from "../../lib/cn";

function Input({ className, type, id: idProp, ...props }: React.ComponentProps<"input">) {
  const generatedId = React.useId();
  const id = idProp ?? generatedId;
  return (
    <input
      type={type}
      id={id}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-[--placeholder-foreground] selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-sm shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 max-md:text-base!",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
